import { combineReducers } from 'redux';
import prepareBody from '../utils/prepareBody';
import { GET_RACE_SUCCESS } from './race';
import { selectPlanId, selectRunnerId } from './auth';

export const SAVE_PREFERENCES = 'preference/SAVE_PREFERENCES';
export const SAVE_PREFERENCES_SUCCESS = 'preference/SAVE_PREFERENCES_SUCCESS';
export const SAVE_PREFERENCES_FAILURE = 'preference/SAVE_PREFERENCES_FAILURE';
export const CHANGE_FIELD = 'preference/CHANGE_FIELD';
export const SET_DEFFERED_PROMPT = 'preference/SET_DEFFERED_PROMPT';
export const TOGGLE_MODAL = 'preference/TOGGLE_MODAL';
export const TOGGLE_WELCOME = 'preference/TOGGLE_WELCOME';
export const TOGGLE_TRAINING_PLAN_MODAL = 'preference/TOGGLE_TRAINING_PLAN_MODAL';
export const TOGGLE_ADD_TO_HOMESCREEN = 'preference/TOGGLE_ADD_TO_HOMESCREEN';
export const CLOSE_MODAL = 'preference/CLOSE_MODAL';

const readFromRace = (result) => {
    const pref = {};
    const fields = [
        'lrday', 'doday', 'alerts', 'lock', 'favwo', 'treadmill', 'Strava',
    ];

    fields.forEach((field) => {
        pref[field] = result[field];
    });

    return pref;
};

export function formReducer(state = {}, action) {
    switch (action.type) {
        case GET_RACE_SUCCESS:
            return {
                ...state,
                ...readFromRace(action.result),
            };
        case CHANGE_FIELD:
            return {
                ...state,
                [action.key]: action.val,
            };
        default:
            return state;
    }
}

export function valuesReducer(state = {}, action) {
    switch (action.type) {
        case GET_RACE_SUCCESS:
            return readFromRace(action.result);
        case SAVE_PREFERENCES_SUCCESS:
            return action.body;
        default:
            return state;
    }
}

export function modalReducer(state = false, action) {
    switch (action.type) {
        case GET_RACE_SUCCESS:
            return action.result.lrday === action.result.doday;
        case SAVE_PREFERENCES_SUCCESS:
            return false;
        case TOGGLE_MODAL:
            return !state;
        default:
            return state;
    }
}

export function trainingPlanModalReducer(state = false, action) {
    switch (action.type) {
        case TOGGLE_TRAINING_PLAN_MODAL:
            return !state;
        default:
            return state;
    }
}

export function welcomeReducer(state = true, action) {
    switch (action.type) {
        case TOGGLE_WELCOME:
            return !state;
        default:
            return state;
    }
}

export function addToHomeScreenReducer(state = false, action) {
    switch (action.type) {
        case SAVE_PREFERENCES_SUCCESS:
        case TOGGLE_ADD_TO_HOMESCREEN:
            return !state;
        default:
            return state;
    }
}

export function defferedPromptReducer(state = 'undefined', action) {
    switch (action.type) {
        case SET_DEFFERED_PROMPT:
            return action.beforeInstallPrompt;
        default:
            return state;
    }
}

export function loading(state = false, action) {
    switch (action.type) {
        case SAVE_PREFERENCES:
            return true;
        case SAVE_PREFERENCES_SUCCESS:
        case SAVE_PREFERENCES_FAILURE:
            return false;
        default:
            return state;
    }
}

export default combineReducers({
    form: formReducer,
    values: valuesReducer,
    modal: modalReducer,
    welcome: welcomeReducer,
    addToHomeScreen: addToHomeScreenReducer,
    defferedPrompt: defferedPromptReducer,
    trainingPlanModal: trainingPlanModalReducer,
    loading,
});

export const toggleModalAction = () => ({
    type: TOGGLE_MODAL,
});

export const toggleTrainingPlanModal = () => ({
    type: TOGGLE_TRAINING_PLAN_MODAL,
});

export const toggleWelcomeAction = () => ({
    type: TOGGLE_WELCOME,
});

export const addToHomeScreenAction = () => ({
    type: TOGGLE_ADD_TO_HOMESCREEN,
});

export const changeField = (key, val) => ({
    type: CHANGE_FIELD,
    key,
    val,
});
export const setDefferedPrompt = beforeInstallPrompt => ({
    type: SET_DEFFERED_PROMPT,
    beforeInstallPrompt,
});

export const savePreferences = (body, page = '') => ({
    types: [SAVE_PREFERENCES, SAVE_PREFERENCES_SUCCESS, SAVE_PREFERENCES_FAILURE],
    promise: ({ getState }) => fetch(`${process.env.RTAPI_URL}/API_manage_training.php`, {
        method: 'POST',
        body: prepareBody({
            plan_id: selectPlanId(getState()),
            runner_id: selectRunnerId(getState()),
            ...body,
        }),
    }).then(res => res.json()),
    body,
    page,
});



/** WEBPACK FOOTER **
 ** ./src/redux/preferences.js
 **/